module.exports = __webpack_public_path__ + "static/img/nbg_choropleth.39237afb.png";